import { LinkItem, FlexItem } from './styles'

const LinkMenuItem: React.FC<{ href?: string; target?: string; onClick?: () => void }> = ({
  href,
  target,
  onClick,
  children,
}) => {
  if (href)
    return (
      <LinkItem href={href} target={target} py="1.125em">
        {children}
      </LinkItem>
    )

  return (
    <FlexItem onClick={onClick} py="1.125em">
      {children}
    </FlexItem>
  )
}

export default LinkMenuItem
